interface IntervalParams {
  min: number
  max: number
}

export function getLeverageButtonsValue({ min, max }: IntervalParams): number[] {
  const intervals: number[] = []
  let currentValue = min

  while (currentValue <= max) {
    intervals.push(currentValue)
    if (currentValue < 10) currentValue = Math.round((currentValue + 4) / 5) * 5
    else if (currentValue < 100) currentValue = Math.round((currentValue + 40) / 50) * 50
    else currentValue = Math.round((currentValue + 400) / 500) * 500
  }

  if ((intervals?.at(-1) || max) < max) intervals.push(max)

  return intervals
}
